import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from 'containers/Header';
import { createStructuredSelector } from 'reselect';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import { language } from 'utils/literals';
import { stateLiteral } from 'utils/statesLiterals';
import {
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectPerfilesUsuarioIdUsuario,
  makeSelectPerfilesUsuarioNombreUsuario,
} from 'store/usuarios/selectors';
import {
  resetCreatePracticeForm,
  setModalDraftType,
  setObservacionesAlumno,
  setObservationsSelected,
  setStartDateTimeSelectedJourney,
  setFinishDateTimeSelectedJourney,
  setStateType,
  setStartDateTimeSelectedPreparation,
  setStartDateTimeSelectedService,
  setFinishDateTimeSelectedService,
  setDisposicionPracticeSelected,
  resetStartCreatePracticeForm,
} from 'store/app/actions';
import { Redirect, useHistory } from 'react-router-dom';
import { RouteTypes } from 'consts';
import './practice-create.scss';
import JourneysContainer from 'containers/journeysContainer';
import ServicesContainer from 'containers/servicesContainer';
import StationsContainer from 'containers/stationContainer';
import InstructorsContainer from 'containers/instructorContainer';
import PracticeInformation from 'containers/practiceInformation';
import {
  RfUiBreadcrumbs,
  RfUiButton,
  RfUiInput,
  RfUiModal,
} from 'renfe-components';
import {
  crearPracticaRequest,
  getJornadasUsuarioRequest,
  resetPracticaSeleccionada,
  resetPracticasByJornada,
} from 'store/practicas/actions';
import {
  makeSelectModalDraftType,
  makeSelectMsgSubmit,
  makeSelectPracticaCreada,
  makeSelectStateType,
  makeSelectObservacionesAlumno,
  makeSelectCanCreateDraft,
  makeSelectCanCreatePractice,
} from 'store/app/selectors';
import {
  makeSelectCrearPracticaRequestStatus ,
} from 'store/practicas/selectors';

import { userProfile } from 'utils/profilesIndex';
import { PracticeFormLegend } from './PracticeFormLegend/PracticeFormLegend';
import { ObservationsContainer } from 'containers/observationsContainer';
import { PreparationTimeContainer } from 'containers/preparationTimeContainer';
import { deleteSavedPagination } from 'utils/practiceUtils';
import { RequestStatusTypes } from '../../consts';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  access_token: makeSelectTokenAccessToken(),
  nombreUsuario: makeSelectPerfilesUsuarioNombreUsuario(),
  idUsuario: makeSelectPerfilesUsuarioIdUsuario(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  statePractice: makeSelectStateType(),
  practicaCreada: makeSelectPracticaCreada(),
  observationsAlumn: makeSelectObservacionesAlumno(),
  canCreateDraft: makeSelectCanCreateDraft(),
  canCreatePractice: makeSelectCanCreatePractice(),
  crearPracticaRequestStatus: makeSelectCrearPracticaRequestStatus(),
} as any);

const links = [
  {
    label: 'Crear práctica',
    link: '/practice/create',
    textHelp: 'Crear práctica',
    active: true,
  },
];

const CreatePractice = (): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    profileActive,
    access_token,
    msgSubmit,
    modalDraftType,
    nombreUsuario,
    idUsuario,
    statePractice,
    observationsAlumn,
    canCreateDraft,
    canCreatePractice,
    crearPracticaRequestStatus,
  } = useSelector<any, any>(selectors);

  const [triggerResetFiltersState, setResetFiltersState] = useState(false);
  //DEAHBILITAR BOTÓN DE ENVÍO HASTA RECIBIR RESPUES
  const [isSubmittingPractice, setIsSubmittingPractice] = useState(false);

  useEffect(() => {
    dispatch(resetStartCreatePracticeForm());
  }, []);

  useEffect(() => {
    cleanCreatePracticeForm();
  }, [dispatch]);
  useEffect(() => {
    if (
      crearPracticaRequestStatus?.status === RequestStatusTypes.Success ||
      crearPracticaRequestStatus?.status === RequestStatusTypes.Error
    ) {
      setIsSubmittingPractice(false);
    }
  }, [crearPracticaRequestStatus]);

  useEffect(() => {
    if (
      crearPracticaRequestStatus?.status === RequestStatusTypes.Success ||
      crearPracticaRequestStatus?.status === RequestStatusTypes.Error
    ) {
      setIsSubmittingPractice(false);
    }
  }, [crearPracticaRequestStatus]);

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  if (
    (profileActive?.ID_PERFIL === userProfile.alumno.extAspirante ||
      profileActive?.ID_PERFIL === userProfile.alumno.extBecario ||
      profileActive?.ID_PERFIL === userProfile.alumno.extMaquinista ||
      profileActive?.ID_PERFIL === userProfile.alumno.intBecario ||
      profileActive?.ID_PERFIL === userProfile.alumno.intMaquinista) &&
    profileActive?.ACTIVO === 'N'
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  if (
    profileActive?.ID_PERFIL === userProfile.instructor ||
    profileActive?.ID_PERFIL === userProfile.gestor ||
    profileActive?.ID_PERFIL === userProfile.formador ||
    profileActive?.ID_PERFIL === userProfile.administrador ||
    profileActive.ID_PERFIL === userProfile.supervisor ||
    profileActive.ID_PERFIL === userProfile.visualizador
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  const cleanCreatePracticeForm = () => {
    dispatch(resetCreatePracticeForm());
    dispatch(setDisposicionPracticeSelected('N'));
    prepareEmptyDates();
    dispatch(resetPracticaSeleccionada());
    dispatch(setObservationsSelected(''));
    dispatch(setObservacionesAlumno(''));
    dispatch(resetPracticasByJornada());
  };

  // Asignamos a las fechas vacías la fecha actual
  const prepareEmptyDates = () => {
    const dateNow = new Date();
    dateNow.setHours(0, 0, 0, 0);
    dispatch(setStartDateTimeSelectedJourney(dateNow));
    dispatch(setFinishDateTimeSelectedJourney(dateNow));
    dispatch(setStartDateTimeSelectedPreparation(dateNow));
    dispatch(setStartDateTimeSelectedService(dateNow));
    dispatch(setFinishDateTimeSelectedService(dateNow));
  };

  const handleObservations = (observation: any) => {
    dispatch(setObservacionesAlumno(observation));
  };

  const handleClickCreateDraftButton = () => {
    dispatch(setStateType(stateLiteral.borrador));
    dispatch(crearPracticaRequest());
    checkRedirect();
  };

  //DEAHBILITAR BOTÓN DE ENVÍO HASTA RECIBIR RESPUES
  const handleClickSubmitButton = () => {
    if (isSubmittingPractice) {
      return;
    }

    setIsSubmittingPractice(true);
    dispatch(setStateType(stateLiteral.pendValidar));
    dispatch(crearPracticaRequest());
    checkRedirect();
  };


  const checkRedirect = () => {
    if (modalDraftType === 'success') {
      deleteSavedPagination(window.location.pathname, false, true);
      if (statePractice === stateLiteral.borrador) {
        dispatch(resetCreatePracticeForm());
        setResetFiltersState(!triggerResetFiltersState);
        dispatch(getJornadasUsuarioRequest());
      }
      if (statePractice === stateLiteral.pendValidar) {
        dispatch(resetCreatePracticeForm());
        setResetFiltersState(!triggerResetFiltersState);
        dispatch(getJornadasUsuarioRequest());
      }
    }
  };

  return (
    <>
      <Header />
      <div className="rf-layout rf-layout__desktop">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">
          {language.informacionPractica.crearPracticaLabel}
        </h1>
        <h2 className="rf-title rf-title--secundary rf-title--hide-mobile">
          {language.informacionPractica.alumnoLabel}
        </h2>
        <div className="rf-container-box">
          <div className="rf-box--user">
            <div>
              <div className="rf-box__child">
                <div className="rf-practice-create__input-container">
                  <RfUiInput
                    label={language.informacionPractica.alumnoNombre}
                    error=""
                    className="rf-input"
                    disabled={true}
                    value={idUsuario + ' - ' + nombreUsuario}
                  ></RfUiInput>
                </div>
              </div>
            </div>
          </div>
          <div className="rf-flex rf-justify-start rf-align-center rf-text-align-right rf-block--mobile rf-text-align-center--mobile rf-padding-15">
            <RfUiButton
              text={language.informacionPractica.limpiar}
              text-help={language.informacionPractica.limpiar}
              aspect="secondary"
              onClick={cleanCreatePracticeForm}
              className="rf-button rf-ui-button--link"
            >
              {' '}
            </RfUiButton>
          </div>
        </div>
        <div className="rf-box">
          <JourneysContainer />
          <PreparationTimeContainer />
          <ServicesContainer />
          <StationsContainer triggerResetFilters = {triggerResetFiltersState} />
          <InstructorsContainer />
          <ObservationsContainer
            title={language.informacionPractica.observationsAlumnLabel}
            disableObservationAlumn={false}
            valueObservation={observationsAlumn}
            handleObservationsChange={handleObservations}
          />
        </div>
        <div className="rf-box">
          <h2 className="rf-title rf-title--secundary">
            {language.informacionPractica.validacionLabel}
          </h2>
          <div className="rf-practice-create__input-container">
            <RfUiInput
              label={language.informacionPractica.estadoLabel}
              error=""
              className="rf-input"
              disabled={true}
            ></RfUiInput>
          </div>
          <div className="rf-practice-create__container rf-flex rf-justify-start rf-align-center rf-text-align-right rf-block--mobile rf-text-align-center--mobile">
            <div className="rf-practice-create__button-container">
              <RfUiButton
                text={language.informacionPractica.grabarBorradorLabel}
                type="button"
                aspect="white"
                className="rf-button"
                disabled={!canCreateDraft}
                onClick={handleClickCreateDraftButton}
              />
            </div>
            <div className="rf-practice-create__button-container">
            <RfUiButton
              text={language.informacionPractica.enviarLabel}
              type="button"
              aspect="primary"
              className="rf-button"
              disabled={!canCreatePractice || isSubmittingPractice}
              onClick={handleClickSubmitButton}
            />
            </div>
            {/* <div>
              <span>{msgSubmit}</span>
            </div> */}
          </div>

          <PracticeFormLegend />
          <PracticeInformation />

          {/* TODO: Implement in redux */}
          <RfUiModal
            title-modal={msgSubmit}
            id-modal="modalDraft"
            modal-type={modalDraftType}
            onModalClose={(e: any) => {
              dispatch(setModalDraftType(''));
              checkRedirect();
            }}
          ></RfUiModal>
        </div>
      </div>

      <div className="rf-layout rf-layout__mobile">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">
          {language.informacionPractica.crearPracticaLabel}
        </h1>
        <h2 className="rf-title rf-title--secundary rf-title--hide-mobile">
          {language.informacionPractica.alumnoLabel}
        </h2>
        <div className="rf-container-box">
          <div className="rf-box--user">
            <div>
              <div className="rf-box__child">
                <div className="rf-practice-create__input-container">
                  <RfUiInput
                    label={language.informacionPractica.alumnoNombre}
                    error=""
                    className="rf-input"
                    disabled={true}
                    value={idUsuario + ' - ' + nombreUsuario}
                  ></RfUiInput>
                </div>
              </div>
            </div>
          </div>
          <div>
            <RfUiButton
              text={language.informacionPractica.limpiar}
              text-help={language.informacionPractica.limpiar}
              aspect="secondary"
              onClick={cleanCreatePracticeForm}
              className="rf-button rf-ui-button--link"
            >
              {' '}
            </RfUiButton>
          </div>
        </div>
        <div className="rf-box">
          <JourneysContainer />
          <PreparationTimeContainer />
          <ServicesContainer />
          <PracticeInformation />
        </div>
        <div className="rf-box">
          <StationsContainer triggerResetFilters = {triggerResetFiltersState} />
          <InstructorsContainer />
          <ObservationsContainer
            title={language.informacionPractica.observationsAlumnLabel}
            disableObservationAlumn={false}
            valueObservation={observationsAlumn}
            handleObservationsChange={handleObservations}
          />
          <h2 className="rf-title rf-title--secundary">
            {language.informacionPractica.validacionLabel}
          </h2>
          <div className="rf-practice-create__input-container">
            <RfUiInput
              label={language.informacionPractica.estadoLabel}
              error=""
              className="rf-input"
              disabled={true}
            ></RfUiInput>
          </div>
          <div className="rf-practice-create__container rf-flex rf-justify-end rf-align-center rf-text-align-right rf-block--mobile rf-text-align-center--mobile">
            <div className="rf-practice-create__button-container">
              <RfUiButton
                text={language.informacionPractica.grabarBorradorLabel}
                type="button"
                aspect="white"
                className="rf-button"
                disabled={!canCreateDraft}
                onClick={handleClickCreateDraftButton}
              />
            </div>
            <div className="rf-practice-create__button-container">
            <RfUiButton
              text={language.informacionPractica.enviarLabel}
              type="button"
              aspect="primary"
              className="rf-button"
              disabled={!canCreatePractice || isSubmittingPractice}
              onClick={handleClickSubmitButton}
            />
            </div>
          </div>
          <PracticeFormLegend />
          {/* TODO: Implement in redux */}
          <RfUiModal
            title-modal={msgSubmit}
            id-modal="modalDraft"
            modal-type={modalDraftType}
            onModalClose={(e: any) => {
              dispatch(setModalDraftType(''));
              checkRedirect();
            }}
          ></RfUiModal>
        </div>
      </div>
    </>
  );
};

export default CreatePractice;
